import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/kanban')({
  beforeLoad: () => {
    throw redirect({
      to: '/inbox',
      search: { view: 'kanban' },
    })
  },
})
